import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { PlayerState } from './player.reducer';

export const $playerState = (state: AppState): PlayerState => state.player;

export const $sitePlayer = createSelector($playerState, state => state.player);

export const $playerOptions = createSelector(
    $playerState,
    state => state.playerOptions,
);

